import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncSpotifyToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.syncSpotifyToYoutube}
            sections={<PairSyncGuideContent sourceKey="spotify" destKey="youtube" />}
        />
    );
}
